import { render, staticRenderFns } from "./ContactControls.vue?vue&type=template&id=0a63f6fa"
import script from "./ContactControls.vue?vue&type=script&lang=js"
export * from "./ContactControls.vue?vue&type=script&lang=js"
import style0 from "./ContactControls.vue?vue&type=style&index=0&id=0a63f6fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports